import React from 'react';
import '../../Styles/Contact.css'; 

const MapComponent = () => {
  return (
    <div className="map-container">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3980.3070658323572!2d73.174966076188!3d33.51940904567664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dff206d49e3247%3A0xc36973d93ffa92c5!2sInstitute%20of%20Space%20Technology%20(IST)!5e1!3m2!1sen!2s!4v1727675414709!5m2!1sen!2s"
        width="600" 
        height="250" 
        style={{ border: 0 }}
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade"
        title="Institute of Space Technology Map"
      ></iframe>
    </div>
  );
}

export default MapComponent;
